module.exports = __webpack_public_path__ + "img/ico_d_arrow.8a04b1e8.svg";